import axios from "axios";
import { aspNetUrl, newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";

export const AddNewSalesPost = (data) => {
  return axios.post(`${aspNetUrl}sale`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const UpdateStationToSalePost = (data) => {
  return axios.post(`${aspNetUrl}sale/addStation`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const UpdateProductToSalePost = (data) => {
  return axios.post(`${aspNetUrl}sale/addProduct`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
export const DeleteSale = (saleId) => {
  return axios.post(
    `${aspNetUrl}sale/deleteList/${saleId}`,
    {},
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const GetSalesList = (stationId) => {
  return axios.get(`${newApiBaseUrl}/promotions`, {
    params: { branch: stationId },
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const fetchFullProductsForSales = (promos, branch) => {
  return async (dispatch) => {
    try {
      const productRequests = promos
        .map((promo) => {
          const gtin = promo.targetProducts?.[0];
          if (!gtin) return null;
          return axios.get(`${newApiBaseUrl}/admin/products`, {
            params: { branch: branch, productIds: `${gtin}-000` },
            headers: {
              Authorization: `bearer ${localStorage.jwtToken}`,
              "X-Tenant": "hamazon",
            },
          });
        })
        .filter(Boolean);

      const responses = await Promise.all(productRequests);
      const fullProducts = responses.map((res) => res.data[0]).filter(Boolean);

      dispatch({
        type: actionType.SET_PRODUCTS,
        payload: { items: fullProducts }, // ה-Reducer יכניס את זה ל-itemsShow
      });
    } catch (error) {
      console.error("Error fetching sales:", error);
    }
  };
};
export const GetProductList = (saleId) => {
  return axios.get(`${aspNetUrl}sale/Product?SaleId=${saleId}`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const GetSalePrice = (mkt, stationId) => {
  return axios.get(
    `${aspNetUrl}sale/GetSalePrice?mkt=${mkt}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};
